export const MATERIAL_STEPS_NUMBER = 7;
export const TRANSPORT_STEPS_NUMBER = 2;
export const COMPANY_INFO_STEPS_NUMBER = 8;
export const REG_EMAIl = /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
